import { PayloadAction } from "@reduxjs/toolkit";

import { MyFleetState } from "../../types";

export const setActiveDisplay = (
  state: MyFleetState,
  action: PayloadAction<MyFleetState["activeDisplay"]>
) => {
  state.activeDisplay = action.payload;
};
